module.exports = __webpack_public_path__ + "static/img/new_logo_4.a538c773.png";